export default {
    curriculumCategories:       { method: 'get',    url: 'curriculum_categories' },
    createCurriculumCategory:   { method: 'post',   url: 'curriculum_categories'},
    updateCurriculumCategory:   { method: 'put',    url: 'curriculum_categories/{id}'},
    deleteCurriculumCategory:   { method: 'delete', url: 'curriculum_categories/{id}'}
}